import React from 'react'
import Navbar from './Components/Navbar/Navbar'
import Card from './Components/Cards/Card'
import Day from './Components/Day/Day'

function App() {
  return (
    <div>
      <Navbar/>
      <Card/>
      <Day/>
    </div>
  )
}

export default App